import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import logoDark from "../../assets/images/logo192.png";
import logoLight from "../../assets/images/logo192.png";
import logo from "../../assets/images/Go_Safe_Logo.png";

export const Navbar = ({ navDark, manuClass, containerClass }) => {
  const [show, setShow] = useState(false);
  const [showTwo, setShowTwo] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [isMenu, setisMenu] = useState(false);
  const [modal, setModal] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseTwo = () => setShowTwo(false);
  const handleShowTwo = () => setShowTwo(true);

  const [manu, setManu] = useState("");
  const location = useLocation();

  useEffect(() => {
    const current = location.pathname.substring(
      location.pathname.lastIndexOf("/") + 1
    );
    setManu(current);

    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
    window.scrollTo(0, 0);
    const closeModal = () => {
      setModal(false);
    };
    document.addEventListener("mousedown", closeModal);
    return () => {
      document.removeEventListener("mousedown", closeModal);
    };
  }, []);

  let toggleMenu = () => {
    setisMenu(!isMenu);
    if (document.getElementById("navigation")) {
      const anchorArray = Array.from(
        document.getElementById("navigation").getElementsByTagName("a")
      );
      anchorArray.forEach((element) => {
        element.addEventListener("click", (elem) => {
          const target = elem.target.getAttribute("href");
          if (target !== "") {
            if (elem.target.nextElementSibling) {
              var submenu = elem.target.nextElementSibling.nextElementSibling;
              submenu.classList.toggle("open");
            }
          }
        });
      });
    }
  };

  return (
    <header
      id="topnav"
      className={`${scroll ? "nav-sticky" : "nav-sticky"} navigation sticky`}
    >
      <div className={containerClass}>
        <div>
          {navDark === true ? (
            <Link className="logo" to="/">
              <img
                src={logo}
                height="22"
                className="logo-light-mode"
                alt=""
              />
              <img
                src={logo}
                height="22"
                className="logo-dark-mode"
                alt=""
              />
            </Link>
          ) : (
            <Link className="logo " to="/">
            <img
              src={logo} // Replace this with your actual PNG path
              height="50" // Adjust height as needed
              alt="GOSAFE Logo"
            />
          </Link>
          )}
        </div>

        <div className="menu-extras">
          <div className="menu-item">
            <Link
              to="#"
              className={`navbar-toggle ${isMenu ? "open" : ""}`}
              id="isToggle"
              onClick={() => toggleMenu()}
            >
              <div className="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </Link>
          </div>
        </div>

        <ul className="dropdowns list-inline mb-0">
          <li className="list-inline-item mb-0">
            <Link to={"/auth/signup"}>
              <div className="d-none d-lg-block btn btn-primary">
                Crea tu cuenta
              </div>
            </Link>
          </li>

          <li className="list-inline-item mb-0 ms-1">
            <Link to={"/auth/login"}>
              <div className="d-none d-lg-block btn btn-primary">
                Ingresa
              </div>
            </Link>
          </li>
        </ul>

        <div id="navigation" style={{ display: isMenu ? "block" : "none" }}>
          <ul className={manuClass}>
            <li
              className={`${
                ["signup"].includes(manu) ? "active" : ""
              } has-submenu parent-menu-item d-lg-none`}
            >
              <Link to="/auth/signup">Crea tu cuenta</Link>
            </li>

            <li
              className={`${
                ["login"].includes(manu) ? "active" : ""
              } has-submenu parent-menu-item d-lg-none`}
            >
              <Link to="/auth/login">Iniciar sesion</Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};
